'use strict'

module.exports = '/spdy/3.1.0'



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-spdy/src/spdy-codec.js
// module id = 122
// module chunks = 0